module.exports = __webpack_public_path__ + "img/plan-salon-2026.b60b5d1e.png";